import { 
  FaStar, FaReact, FaDatabase, FaLayerGroup, FaJs, FaCode
} from 'react-icons/fa';
import { 
  SiMongodb, SiDotnet, SiTypescript, SiJavascript, SiTailwindcss, SiGithub 
} from 'react-icons/si';
import { 
  HiOutlineExternalLink, HiOutlineGlobe, HiOutlineTerminal, 
  HiOutlineDeviceTablet, HiOutlineBookOpen, HiOutlinePuzzle, 
  HiOutlineDuplicate, HiOutlineServer, HiOutlinePencil, 
  HiOutlineSun, HiOutlineClipboardList, HiOutlineCurrencyDollar,
  HiOutlineUserGroup, HiOutlineViewGrid, HiOutlineArrowCircleUp,
  HiOutlineHand, HiOutlineX, HiOutlineShoppingBag, HiOutlineCube,
  HiOutlineSearch
} from 'react-icons/hi';
import { IoGameControllerOutline } from 'react-icons/io5';
import { useState, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const PROJECTS = [
 
  
  { 
    title: 'Gadd Kaam — SkillSwap Pakistan -MERN Stack - FYP', 
    icon: <HiOutlineUserGroup />, 
    desc: 'A secure, MERN-stack platform for cashless skill exchanging featuring CNIC verification and real-time trading.', 
    tech: ['MongoDB', 'Express.js', 'React.js', 'Node.js'], 
    live: 'https://gadd-kaam-skillswap-pakistan.netlify.app/', 
    code: 'https://github.com/farmanullah1/Gadd-Kaam-SkillSwap-Pakistan', 
    featured: true 
  },
  { 
    title: 'MindBook - Social Media Platform', 
    icon: <HiOutlineUserGroup />, 
    desc: 'A comprehensive social networking platform built with the MERN stack, featuring user authentication, post creation, and real-time interactions.', 
    tech: ['MongoDB', 'Express.js', 'React.js', 'Node.js', 'TypeScript'], 
    live: 'https://farmanullah1.github.io/MindBook---MERN/', 
    code: 'https://github.com/farmanullah1/MindBook---MERN',
    featured: true
  },
  
  { 
    title: 'Nexa-Habit-Habit-Tracker-App', 
    icon: <HiOutlineSun />, 
    desc: 'Nexa Habit is a modern, high-performance habit tracking web application designed with a Glassmorphism aesthetic (inspired by iOS design language). It features soft gradients, deep blur effects, and smooth animations to provide a calm and focused productivity experience.', 
    tech: ['React.js', 'Framer Motion', 'OpenWeatherMap', 'WeatherAPI'], 
    live: 'https://farmanullah1.github.io/Nexa-Habit-Habit-Tracker-App/', 
    code: 'https://github.com/farmanullah1/Nexa-Habit-Habit-Tracker-App'
  },
   { 
    title: 'fridge.pk - E-commerce Platform', 
    icon: <HiOutlineShoppingBag />, 
    desc: 'A specialized e-commerce platform for home appliances, featuring a modern React-based UI, product filtering, and a seamless shopping experience.', 
    tech: ['React.js', 'TypeScript', 'Tailwind CSS', 'Framer Motion'], 
    live: 'https://farmanullah1.github.io/fridge.pk-E-commerce-platform-React/', 
    code: 'https://github.com/farmanullah1/fridge.pk-E-commerce-platform-React', 
    featured: false 
  },
  { 
    title: 'SkyCast - Weather Dashboard - React.js', 
    icon: <HiOutlineSun />, 
    desc: 'A fully functional, modern, and animated Weather Dashboard built with React, Vite, Framer Motion, OpenWeatherMap, and WeatherAPI. Features include real-time weather data, a 5-day forecast, hourly forecast, stunning dynamic backgrounds, temperature unit toggling, and geolocation support.', 
    tech: ['React.js', 'Framer Motion', 'Tailwind CSS'],  
    live: 'https://farmanullah1.github.io/SkyCast--Weather-Dashboard/', 
    code: 'https://github.com/farmanullah1/SkyCast--Weather-Dashboard'
  },
  { 
    title: 'Taskly - Modern Todo Task Manager App - React.js', 
    icon: <HiOutlineClipboardList />, 
    desc: 'A sleek and efficient task management application with a beautiful glassmorphism UI, task persistence, and smooth Framer Motion animations.', 
    tech: ['React.js', 'Framer Motion', 'Tailwind CSS'], 
    live: 'https://farmanullah1.github.io/Taskly---Modern-Todo-Task-Manager-App/', 
    code: 'https://github.com/farmanullah1/Taskly---Modern-Todo-Task-Manager-App'
  },
  { 
    title: 'KALEIDO - Modern eCommerce Store', 
    icon: <HiOutlineCube />, 
    desc: 'A premium, high-performance eCommerce application leveraging the MERN stack for a robust shopping experience with advanced state management.', 
    tech: ['MongoDB', 'Express.js', 'React.js', 'Node.js', 'TypeScript'], 
    live: 'https://farmanullah1.github.io/KALEIDO-eCommerce--MERN/', 
    code: 'https://github.com/farmanullah1/KALEIDO-eCommerce--MERN',
    featured: false
  },
  { 
    title: 'BalanceByte - ASP.NET Core', 
    icon: <HiOutlineCurrencyDollar />, 
    desc: 'Simple mobile balance checker with smooth UI transitions that tells you how much total balance you will get if you load a specific amount (e.g., load 100)', 
    tech: ['C#', 'ASP.NET Core', 'MVC', 'SQL Server'], 
    live: '', 
    code: 'https://github.com/farmanullah1/BalanceByte-ASP.NET-Core-MVC-App'
  },
  { 
    title: 'iNotebook - Cloud Notes', 
    icon: <HiOutlineBookOpen />, 
    desc: 'Secure MERN stack application for managing notes on the cloud, featuring JWT authentication and persistent storage.', 
    tech: ['Node.js', 'React.js', 'MongoDB', 'Express'], 
    live: 'https://farmanullah1.github.io/iNotebook/', 
    code: 'https://github.com/farmanullah1/iNotebook' 
  },
  { 
    title: 'Kurrent News', 
    icon: <HiOutlineGlobe />, 
    desc: 'A global news SPA featuring a Triple-API fallback architecture, infinite scrolling, and dark mode.', 
    tech: ['React.js', 'NewsAPI', 'Bootstrap'], 
    live: 'https://farmanullah1.github.io/Kurrent-News-Top-Headlines-Tech-Politics-Sports/', 
    code: 'https://github.com/farmanullah1/Kurrent-News-Top-Headlines-Tech-Politics-Sports' 
  },
  { 
    title: 'Memory Card Matching Game', 
    icon: <HiOutlinePuzzle />, 
    desc: 'A beautiful, fully responsive memory card matching game built with React, TypeScript, and Vite. This game features smooth animations, multiple themes, sound effects, and high score tracking.', 
    tech: ['React.js', 'TypeScript', 'Vite'], 
    live: 'https://farmanullah1.github.io/Memory-Card-Matching-Game/', 
    code: 'https://github.com/farmanullah1/Memory-Card-Matching-Game' 
  },
  { 
    title: 'TextRepeat Studio', 
    icon: <HiOutlineDuplicate />, 
    desc: 'Highly efficient text manipulation and repetition tool built with React for rapid content generation and formatting.', 
    tech: ['React.js', 'JavaScript'], 
    live: 'https://farmanullah1.github.io/TextRepeat---React/', 
    code: 'https://github.com/farmanullah1/TextRepeat---React' 
  },
  { 
    title: 'ASP.NET Core CRUD API', 
    icon: <HiOutlineServer />, 
    desc: 'Robust REST API demonstrating repository patterns, efficient CRUD operations, and modern .NET backend practices.', 
    tech: ['C#', 'ASP.NET Core', 'Web API'], 
    live: '', 
    code: 'https://github.com/farmanullah1/CRUD-App-Using-ASP-Core-Web-API' 
  },
  { 
    title: 'BalanceWave - React', 
    icon: <HiOutlineDeviceTablet />, 
    desc: 'Create a mobile balance checker that lets a user enter an amount they want to load (for example, 100), and then shows how much total balance they will get after loading that amount. The interface should be simple, modern, and mobile‑friendly, with smooth transitions.', 
    tech: ['React.js', 'Framer Motion', 'Tailwind CSS'], 
    live: 'https://farmanullah1.github.io/BalanceWave-React/', 
    code: 'https://github.com/farmanullah1/BalanceWave-React' 
  },
  { 
    title: 'Stone, Paper, Scissors', 
    icon: <HiOutlineHand />, 
    desc: 'Interactive browser game featuring dynamic UI updates and classic game logic.', 
    tech: ['HTML', 'CSS', 'JavaScript'], 
    live: 'https://farmanullah1.github.io/Stone-Paper-Scissors-Game-HTML-CSS-JS/', 
    code: 'https://github.com/farmanullah1/Stone-Paper-Scissors-Game-HTML-CSS-JS' 
  },
  { 
    title: 'TextUtils Studio', 
    icon: <HiOutlinePencil />, 
    desc: 'Premium browser-based text manipulation toolkit with a "Deep Cyber Glass" UI offering 100+ formatting, extraction, and cryptography tools.', 
    tech: ['React.js','Bootstrap'], 
    live: 'https://farmanullah1.github.io/TextUtils-React.js/', 
    code: 'https://github.com/farmanullah1/TextUtils-React.js' 
  },
  {
    title: "❌⭕ Tic-Tac-Toe",
    icon: <HiOutlineX />,
    desc: "A classic Tic-Tac-Toe web game featuring responsive design and state management for turn-based gameplay.",
    tech: ["HTML", "CSS", "JavaScript"],
    live: "https://farmanullah1.github.io/Tic-Tac-Toe-HTML-CSS-JS/",
    code: "https://github.com/farmanullah1/Tic-Tac-Toe-HTML-CSS-JS"
  },
  { 
    title: 'Modern Tetris', 
    icon: <HiOutlineViewGrid />, 
    desc: 'A sleek, TypeScript-powered rendition of the classic arcade game featuring fluid animations, score tracking, and progressive difficulty.', 
    tech: ['TypeScript', 'HTML5 Canvas', 'CSS3'], 
    live: 'https://farmanullah1.github.io/Modern-Tetris/', 
    code: 'https://github.com/farmanullah1/Modern-Tetris' 
  },
  { 
    title: 'Classic Snake Game', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'A high-performance Snake game built with TypeScript, emphasizing clean code architecture and responsive controls.', 
    tech: ['TypeScript', 'CSS', 'JavaScript'], 
    live: 'https://farmanullah1.github.io/Snake-Game/', 
    code: 'https://github.com/farmanullah1/Snake-Game' 
  },
  { 
    title: 'Spotify-Node', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'A high-performance Spotify app with node.js, emphasizing clean code architecture and responsive controls.', 
    tech: ['Node.js', 'CSS', 'JavaScript','EJS','reactjs','Vite','Spotify API'], 
    live: 'https://farmanullah1.github.io/Spotify-Node/', 
    code: 'https://github.com/farmanullah1/Spotify-node-' 
  },
{ 
    title: 'Insta-Like-App-Node-Complete', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'A high-performance Instagram-like app with node.js, emphasizing clean code architecture and responsive controls.', 
    tech: ['Node.js', 'CSS', 'JavaScript','EJS','reactjs','Vite','SQL Server'], 
    live: 'https://farmanullah1.github.io/Insta-Like-App-Node-Complete/', 
    code: 'https://github.com/farmanullah1/Insta-Like-App-Node-Complete' 
  },
  { 
    title: 'Trademark Now Pay Later PHP', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'Now Pay Later app with PHP.', 
    tech: ['PHP', 'CSS', 'JavaScript','MySQL'], 
    live: '', 
    code: 'https://github.com/farmanullah1/trademark-now-pay-later-php' 
  },
  { 
    title: 'Trademark Verification Serivces PHP', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'Trademark Verification Serivces app with PHP.', 
    tech: ['PHP', 'CSS', 'JavaScript','MySQL'], 
    live: '', 
    code: 'https://github.com/farmanullah1/trademark-verification-serivces' 
  },
  { 
    title: 'Karachi Biennale', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'Karachi Biennale website.', 
    tech: ['HTML', 'CSS', 'JavaScript','php'], 
    live: 'https://farmanullah1.github.io/karachi-biennale', 
    code: 'https://github.com/farmanullah1/karachi-biennale' 
  },
  { 
    title: 'Markcrest Law', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'Markcrest Law website.', 
    tech: ['HTML', 'CSS', 'JavaScript','PHP','MS SQL Server'], 
    live: 'https://farmanullah1.github.io/markcrest-law', 
    code: 'https://github.com/farmanullah1/markcrest-law' 
  },
  { 
    title: 'NexaShop - Full E-Commerce Platform', 
    icon: <HiOutlineArrowCircleUp />, 
    desc: 'Full E-Commerce Platform website.', 
    tech: ['HTML', 'CSS', 'JavaScript','PHP','MS SQL Server','Dot Net','ASP .Net','Bootstrap','Dot Net MVC','ASP .Net Core','React.js','Redux','Redux Toolkit','React Router','Vite','C#'], 
    live: 'https://farmanullah1.github.io/NexaShop-Full-E-Commerce-Platform', 
    code: 'https://github.com/farmanullah1/NexaShop-Full-E-Commerce-Platform' 
  },
  { 
    title: 'ULTRA FIGHTER X', 
    icon: <HiOutlineTerminal />, 
    desc: 'An action-packed web fighting game featuring animated combat moves, health bars, combo mechanics, and smooth GSAP animations.', 
    tech: ['HTML', 'CSS', 'JavaScript','GSAP'], 
    live: 'https://farmanullah1.github.io/ULTRA-FIGHTER-X/', 
    code: 'https://github.com/farmanullah1/ULTRA-FIGHTER-X' 
  },
  { 
    title: '8 Ball Pool', 
    icon: <HiOutlineTerminal />, 
    desc: 'A classic 8 Ball Pool web game featuring accurate ball collision physics, cue stick controls, and full game-state logic.', 
    tech: ['HTML', 'CSS', 'JavaScript','React.js','Node.js','MySQL','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/8-ball-Pool/', 
    code: 'https://github.com/farmanullah1/8-ball-Pool' 
  },
  { 
    title: 'Ludo', 
    icon: <HiOutlineTerminal />, 
    desc: 'An interactive digital board game of Ludo with multiplayer turn logic, token movement animations, and dice rolling.', 
    tech: ['HTML', 'CSS', 'JavaScript','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/Ludo/', 
    code: 'https://github.com/farmanullah1/Ludo' 
  },
  { 
    title: 'ApexRush-3D-Web-Racing-Game', 
    icon: <HiOutlineTerminal />, 
    desc: 'A high-performance 3D web racing game built with Three.js and React, featuring dynamic camera perspectives and responsive physics.', 
    tech: ['HTML', 'CSS', 'JavaScript','Three.js','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/ApexRush-3D-Web-Racing-Game/', 
    code: 'https://github.com/farmanullah1/ApexRush-3D-Web-Racing-Game' 
  },
  { 
    title: '3D-RACING-GAME', 
    icon: <HiOutlineTerminal />, 
    desc: 'An immersive 3D racing game featuring dynamic tracks, vehicle handling, and responsive controls.', 
    tech: ['HTML', 'CSS', 'JavaScript','Three.js','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/3D-RACING-GAME/', 
    code: 'https://github.com/farmanullah1/3D-RACING-GAME' 
  },
  { 
    title: '2D-RACING-GAME', 
    icon: <HiOutlineTerminal />, 
    desc: 'A fast-paced 2D arcade racing game with obstacle avoidance, smooth collision detection, and score tracking.', 
    tech: ['HTML', 'CSS', 'JavaScript','Three.js','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/2D-RACING-GAME/', 
    code: 'https://github.com/farmanullah1/2D-RACING-GAME' 
  },
  { 
    title: 'Grove AI', 
    icon: <HiOutlineTerminal />, 
    desc: 'An AI-powered web platform with an interactive user interface, smart generative responses, and responsive design.', 
    tech: ['HTML', 'CSS', 'JavaScript','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/Grove-AI/', 
    code: 'https://github.com/farmanullah1/Grove-AI' 
  },
  { 
    title: 'AirShare', 
    icon: <HiOutlineTerminal />, 
    desc: 'A seamless, web-based file and media sharing application engineered for fast, lightweight local-network data transfers.', 
    tech: ['HTML', 'CSS', 'JavaScript','React.js','Vite','Bootstrap','Redux','Redux Toolkit','React Router'], 
    live: 'https://farmanullah1.github.io/AirShare/', 
    code: 'https://github.com/farmanullah1/AirShare' 
  },
  { 
    title: 'Old Portfolio - (2024)', 
    icon: <HiOutlineTerminal />, 
    desc: 'My 2024 Portfolio Website built with HTML,CSS and JavaScript, emphasizing clean code architecture and responsive controls.', 
    tech: ['HTML', 'CSS', 'JavaScript','Web Basics'], 
    live: 'https://farmanullah1.github.io/Portfolio-2024/', 
    code: 'https://github.com/farmanullah1/Portfolio-2024' 
  },
  { 
    title: 'Portfolio - HTML CSS JS (2025)', 
    icon: <HiOutlineTerminal />, 
    desc: 'My Old portfolio website made with HTML, CSS and JavaScript.', 
    tech: ['HTML', 'CSS', 'JavaScript','GSAP'], 
    live: 'https://farmanullah1.github.io/Portfolio-HTML-CSS-JS/', 
    code: 'https://github.com/farmanullah1/Portfolio-HTML-CSS-JS' 
  },
  { 
    title: 'MyPortfolio - (Latest - 2026)', 
    icon: <FaCode />, 
    desc: 'My Portfolio Website built with React.js, emphasizing clean code architecture and responsive controls.', 
    tech: ['React.js', 'CSS', 'JavaScript','GSAP'], 
    live:  'https://farmanullah1.github.io/My-Portfolio/', 
    code: 'https://github.com/farmanullah1/My-Portfolio' 
  },
];
const FILTERS = [
  { name: 'All', icon: <FaLayerGroup /> },
  { name: 'Featured', icon: <FaStar /> },
  { name: 'Full Stack', icon: <FaDatabase /> },
  { name: 'MERN', icon: <SiMongodb /> },
  { name: 'React.js', icon: <FaReact /> },
  { name: '.NET', icon: <SiDotnet /> },
  { name: 'TypeScript', icon: <SiTypescript /> },
  { name: 'JavaScript', icon: <SiJavascript /> },
  { name: 'Games', icon: <IoGameControllerOutline /> },
  { name: 'Tailwind CSS', icon: <SiTailwindcss /> },
  { name: 'Vanilla JS', icon: <FaJs /> },
];

const match = (p, f) => {
  const tech = (p.tech || []).map(t => (t || '').toLowerCase().trim());
  const title = (p.title || '').toLowerCase();
  const desc = (p.desc || '').toLowerCase();
  
  if (f === 'All') return true;
  if (f === 'Featured') return Boolean(p.featured);
  if (f === 'MERN') {
    return tech.includes('mongodb') || title.includes('mern') || desc.includes('mern');
  }
  if (f === 'Full Stack') {
    return tech.includes('mongodb') || tech.includes('sql server') || tech.includes('node.js') || 
           tech.includes('express') || tech.includes('express.js') || tech.includes('asp.net core') || 
           tech.includes('asp.net') || tech.includes('dot net') || tech.includes('c#') || 
           tech.includes('mysql') || tech.includes('php') || title.includes('mern') || title.includes('full stack');
  }
  if (f === 'React.js') {
    return tech.includes('react.js') || tech.includes('react') || tech.includes('reactjs') || title.includes('react');
  }
  if (f === '.NET') {
    return tech.includes('c#') || tech.includes('asp.net core') || tech.includes('asp .net core') || 
           tech.includes('asp.net') || tech.includes('asp .net') || tech.includes('dot net') || 
           tech.includes('mvc') || tech.includes('ms sql server') || title.includes('asp.net') || title.includes('.net');
  }
  if (f === 'TypeScript') return tech.includes('typescript') || tech.includes('ts');
  if (f === 'JavaScript') return tech.includes('javascript') || tech.includes('js');
  if (f === 'Games') {
    const keywords = ['game', 'racing', 'tetris', 'tic-tac-toe', 'scissors', 'matching', 'snake', 'ludo', 'rush', 'apex'];
    return keywords.some(kw => title.includes(kw) || desc.includes(kw));
  }
  if (f === 'Tailwind CSS') return tech.includes('tailwind css') || tech.includes('tailwind');
  if (f === 'Vanilla JS') {
    return (tech.includes('javascript') || tech.includes('html') || tech.includes('css')) && 
           !tech.includes('react.js') && !tech.includes('react') && !tech.includes('reactjs') && 
           !tech.includes('typescript') && !tech.includes('node.js') && !tech.includes('c#') && !tech.includes('asp.net core');
  }
  
  return tech.includes(f.toLowerCase());
};

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const [search, setSearch] = useState('');
  const [visibleCount, setVisibleCount] = useState(8);

  // Pre-calculate project counts per filter
  const filterCounts = useMemo(() => {
    const counts = {};
    FILTERS.forEach(f => {
      counts[f.name] = PROJECTS.filter(p => match(p, f.name)).length;
    });
    return counts;
  }, []);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return PROJECTS.filter(p => {
      const matchesCategory = match(p, filter);
      if (!matchesCategory) return false;
      if (!q) return true;
      const titleMatch = (p.title || '').toLowerCase().includes(q);
      const descMatch = (p.desc || '').toLowerCase().includes(q);
      const techMatch = (p.tech || []).some(t => (t || '').toLowerCase().includes(q));
      return titleMatch || descMatch || techMatch;
    });
  }, [filter, search]);

  const displayed = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;

  const loadMore = () => {
    setVisibleCount(prev => prev + 8);
  };

  const resetFilters = () => {
    setFilter('All');
    setSearch('');
    setVisibleCount(8);
  };

  return (
    <section className="projects" id="projects">
      <motion.h2 initial={{ opacity:0, y:-20 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }}>
        Featured Projects
      </motion.h2>

      {/* Projects Count & Statistics Header */}
      <div className="projects-header-info">
        <span className="projects-stat-badge">
          <FaLayerGroup /> <strong>{PROJECTS.length}</strong> Total Projects
        </span>
        <span className="projects-stat-badge projects-stat-badge--active">
          Showing <strong>{displayed.length}</strong> of <strong>{filtered.length}</strong> {filter === 'All' && !search ? 'Projects' : 'Results'}
        </span>
      </div>

      {/* Search Input for Projects */}
      <div className="projects-search-wrap">
        <HiOutlineSearch className="projects-search-icon" />
        <input
          type="text"
          className="projects-search-input"
          placeholder="Search projects by title, tech (e.g. React, MERN, C#, Game)..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setVisibleCount(8);
          }}
          aria-label="Search projects"
        />
        {search && (
          <button
            type="button"
            className="projects-search-clear"
            onClick={() => setSearch('')}
            aria-label="Clear search"
          >
            <HiOutlineX />
          </button>
        )}
      </div>

      {/* Filter Tabs with Live Project Counts */}
      <div className="filter-container">
        {FILTERS.map(f => {
          const count = filterCounts[f.name] || 0;
          return (
            <motion.button
              key={f.name}
              className={`filter-btn${filter === f.name ? ' active' : ''}`}
              onClick={() => {
                setFilter(f.name);
                setVisibleCount(8);
              }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="filter-icon">{f.icon}</span>
              <span>{f.name}</span>
              <span className="filter-count">{count}</span>
            </motion.button>
          );
        })}
      </div>

      {/* Empty State */}
      {filtered.length === 0 ? (
        <div className="projects-empty">
          <div className="projects-empty-icon"><HiOutlineSearch /></div>
          <h3>No matching projects found</h3>
          <p>
            No projects match {search ? `"${search}" in ` : ''}the <strong>{filter}</strong> category.
          </p>
          <button
            type="button"
            className="projects-reset-btn"
            onClick={resetFilters}
          >
            Reset Filters ({PROJECTS.length} Projects)
          </button>
        </div>
      ) : (
        /* Project Grid */
        <motion.div layout className="project-grid">
          <AnimatePresence mode="popLayout">
            {displayed.map(proj => (
              <motion.div
                className={`project-card${proj.featured ? ' project-card--featured' : ''}`}
                key={proj.title}
                layout
                initial={{ opacity: 0, scale: 0.88 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.88 }}
                transition={{ duration: 0.32 }}
                whileHover={{ y: -9 }}
              >
                {proj.featured && <div className="project-featured-badge"><FaStar /> Featured</div>}
                <div className="project-icon">{proj.icon}</div>
                <h3>{proj.title}</h3>
                <p>{proj.desc}</p>
                <div className="tech-stack">
                  {proj.tech.map((t, i) => (
                    <span key={i}>
                      {t}
                    </span>
                  ))}
                </div>
                <div className="project-links">
                  {proj.live && (
                    <a href={proj.live} target="_blank" rel="noreferrer" className="project-link project-link--live">
                      <HiOutlineExternalLink /> Live Demo
                    </a>
                  )}
                  {proj.code && (
                    <a href={proj.code} target="_blank" rel="noreferrer" className="project-link project-link--code">
                      <SiGithub /> Source Code
                    </a>
                  )}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      )}

      {/* Pagination / More Button */}
      {hasMore && (
        <motion.div className="more-button-container" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }}>
          <motion.button className="more-button" onClick={loadMore} whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }}>
            Show More Projects ({filtered.length - visibleCount} remaining)
          </motion.button>
          {visibleCount > 8 && (
            <motion.button
              className="more-button more-button--secondary"
              onClick={() => setVisibleCount(8)}
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
            >
              Show Less
            </motion.button>
          )}
        </motion.div>
      )}
    </section>
  );
};

export default Projects;